import { inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { MenuView } from "./views/MenuView";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { MenuResourcesPackage } from "./resources/MenuResourcesPackage";
import { MenuController } from "./controllers/MenuController";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { LocalizationModel } from "../../common/models/LocalizationModel";
import { PlayerModel } from "../../common/models/PlayerModel";
import { SettingsModel } from "../../common/models/SettingsModel";
import { AudioController } from "../game/components/AudioController";
import { SpineResourcesPackage } from "../../common/resources/SpineResourcesPackage";
import { BackgroundResourcesPackage } from "../../common/resources/BackgroundResourcesPackage";

@injectable()
export class MenuScene extends Viewable<void> {
    public constructor(
        backgroundResources: BackgroundResourcesPackage,
        commonResources: CommonResourcesPackage,
        menuResources: MenuResourcesPackage,
        spineResources: SpineResourcesPackage,
        localizationModel: LocalizationModel,
        settingsModel: SettingsModel,
        playerModel: PlayerModel,
        menuController: MenuController,
        audioController: AudioController,
        @inject(InjectableInterfaces.ICanvasScaler)
        canvasScaler: ICanvasScaler
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new MenuView(
            backgroundResources,
            commonResources,
            menuResources,
            spineResources,
            settingsModel,
            localizationModel,
            playerModel,
            menuController,
            audioController,
            canvasScaler,
            pcs
        );
        pcs.result.then(
            () => this.operationControls.complete(),
            (reason: unknown) => this.operationControls.error(reason)
        );
    }
}
